function getDefaultHocKy(): number {
  const month = new Date().getMonth() + 1; // getMonth() trả về 0-11, nên +1
  // Nếu tháng >= 8 hoặc <= 1 thì học kỳ 1, ngược lại học kỳ 2
  return (month >= 8 || month <= 1) ? 1 : 2;
}

function getDefaultNamHoc(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1; // getMonth() trả về 0-11

  // Nếu tháng < 9 thì lấy năm trước, ngược lại lấy năm hiện tại
  const startYear = month < 9 ? year - 1 : year;
  return `${startYear}-${startYear + 1}`;
}
export { getDefaultHocKy, getDefaultNamHoc };